import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../pages/Login.vue';
import Home from '../pages/Home.vue';
import Reset from '../pages/Reset.vue';
import ResetConfirm from '../pages/ResetConfirm.vue';
import NewPassword from '../pages/NewPassword.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
  },
  {
    path: '/resetconfirm',
    name: 'ResetConfirm',
    component: ResetConfirm,
  },
  {
    path: '/newpassword/:token',
    name: 'NewPassword',
    component: NewPassword,
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
